import create from "zustand";
import { MARK_CHAT_MESSAGES_AS_READ } from "../apollo-client/mutations";
import { GET_TOTAL_UNREAD_MESSAGES_COUNT } from "../components/layout/courseNav/small-course-nav/getTotalUnreadMessagesCountQuery";

export const useChatStore = create((set, get) => ({
  // Chat state
  chosenChat: null,
  chats: [],
  searchContact: "",
  isChatOpen: false,

  // Chat selection and management
  selectChat: (chat) => {
    const chatData = {
      type: chat?.type,
      chatTitle: chat?.title,
      profilePicture:
        chat?.picture || chat?.otherPrivateChatMember?.profilePicture,
      receiverId: chat?.otherPrivateChatMember?._id || chat?.receiverId,
      chatId: chat?._id || chat?.chatId,
      unreadMessagesCount: chat?.unreadMessagesCount || 0,
      isOnVacation:
        chat?.otherPrivateChatMember?.onHoliday || chat?.isOnVacation,
      isBlockedBy: chat?.isBlockedBy || [],
      isTeachingRequest: chat?.isTeachingRequest || false,
    };

    set({ chosenChat: chatData });
    return chatData;
  },

  // Update chosen chat with new data
  updateChosenChat: (updates) => {
    const currentChat = get().chosenChat;
    if (currentChat) {
      set({
        chosenChat: { ...currentChat, ...updates },
      });
    }
  },

  setChats: (chats) => set({ chats }),
  setSearchContact: (search) => set({ searchContact: search }),
  setIsChatOpen: (isOpen) => set({ isChatOpen: isOpen }),

  // Teaching request management - now chat-specific
  resetTeachingRequest: () => {
    const currentChat = get().chosenChat;
    if (currentChat) {
      set({
        chosenChat: { ...currentChat, isTeachingRequest: false },
      });
    }
  },

  // Mark messages as read - this will be called from components with access to Apollo client
  markMessagesAsRead: async (chatId, client) => {
    try {
      await client.mutate({
        mutation: MARK_CHAT_MESSAGES_AS_READ,
        variables: { id: chatId },
        refetchQueries: [GET_TOTAL_UNREAD_MESSAGES_COUNT],
      });

      // Update local state
      const currentChat = get().chosenChat;
      if (currentChat && currentChat.chatId === chatId) {
        set({
          chosenChat: { ...currentChat, unreadMessagesCount: 0 },
        });
      }
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  },

  startNewChat: (newChat) => {
    const existingChat = get().chats.find((existingChat) => {
      if (newChat.chatId && existingChat.chatId) {
        return existingChat.chatId === newChat.chatId;
      } else {
        return existingChat.otherPrivateChatMember._id === newChat.receiverId && existingChat.type === newChat.type;
      }
    });

    if (existingChat) {
      get().selectChat(existingChat);
    } else {
      const newChat = {
        type: newChat.type,
        chatTitle: newChat.chatTitle,
        profilePicture: newChat.profilePicture,
        receiverId: newChat.receiverId,
        chatId: newChat.chatId,
        unreadMessagesCount: newChat.unreadMessagesCount,
        isOnVacation: newChat.isOnVacation,
        isBlockedBy: newChat.isBlockedBy || [],
        isTeachingRequest: newChat.isTeachingRequest || false,
      };
      set({ chosenChat: newChat });
    }
  },

  // Reset chat state
  resetChat: () =>
    set({
      chosenChat: null,
      chats: [],
      searchContact: "",
      isChatOpen: false,
    }),
}));
